// extracted by css-extract-rspack-plugin
export default {"a0":"Carousel-cls1_K39","cls1":"Carousel-cls1_fQf","cls2":"Carousel-cls2_sOm Carousel-cls1_fQf"};